/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of real estate property
 * @export
 */
export const PropertyTypeEnum = {
    House: 1,
    Apartment: 2,
    Office: 3,
    Commercial: 4
} as const;
export type PropertyTypeEnum = typeof PropertyTypeEnum[keyof typeof PropertyTypeEnum];


export function instanceOfPropertyTypeEnum(value: any): boolean {
    for (const key in PropertyTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(PropertyTypeEnum, key)) {
            if (PropertyTypeEnum[key as keyof typeof PropertyTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PropertyTypeEnumFromJSON(json: any): PropertyTypeEnum {
    return PropertyTypeEnumFromJSONTyped(json, false);
}

export function PropertyTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyTypeEnum {
    return json as PropertyTypeEnum;
}

export function PropertyTypeEnumToJSON(value?: PropertyTypeEnum | null): any {
    return value as any;
}

export function PropertyTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PropertyTypeEnum {
    return value as PropertyTypeEnum;
}

